require('./beneficiaryExisting.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const { connect } = require('react-redux');
// @ commons
const { formatText, FormattedText } = require('core/i18n').i18n;
const {toCamelCase} = require('utilities/stringHelper');
// @ constants
const { SLASH, COLON } = require ('constants/index');
const { getTranslatedCountry } = require('constants/countries');
// @ components
const SearchBeneficiaries = require('components/searchBeneficiaries/searchBeneficiaries');
const { OKButton } = require('components/commons/OKButton/OKButton');
// @ actions
const beneficiariesActions = require('actions/beneficiaries');
const bankEntityActions = require('actions/bankEntity');
// @helpers
const { isSepa } = require('utilities/transfersHelper');
// @utils
const { recordLinkV2 } = require("utilities/tagging");

class BeneficiaryExisting extends React.Component {

    constructor(props) {
        super(props);

        this.handleBeneficiaryData = this.handleBeneficiaryData.bind(this);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        const { immBeneficiaryExisting, immBeneficiaries, getBankNameFromIban, getBankNameFromBic } = nextProps;
        const beneficiaryId = immBeneficiaryExisting.get('id');
        const iban = immBeneficiaries.getIn(['byId', beneficiaryId, 'iban']);
        const lastIban = this.props.immBeneficiaries.getIn(['byId', this.props.immBeneficiaryExisting.get('id'), 'iban']);
        const bic = immBeneficiaries.getIn(['byId', beneficiaryId, 'bic']);
        const lastBic = this.props.immBeneficiaries.getIn(['byId', this.props.immBeneficiaryExisting.get('id'), 'bic']);

        if (!!beneficiaryId) {
            if (!!iban && (iban != lastIban) ) {
                getBankNameFromIban(iban);
            } else if (!!bic && (bic != lastBic)) {
                getBankNameFromBic(bic);
            }
        }
    }

    buildProfile() {
        const { immBankEntity, immBeneficiaryExisting, immBeneficiaries, actions } = this.props;
        let profileContent;
        const beneficiaryId = immBeneficiaryExisting.get('id');

        if (beneficiaryId) {
            const immContact = immBeneficiaries.getIn(['byId', beneficiaryId]);
            const name = toCamelCase(immContact.get('name'));
            const alias = immContact.get('alias');
            const country = toCamelCase(getTranslatedCountry(immContact.get('country')));
            const isInsideSepa = isSepa(immContact.get('country'), immContact.get('currency'));

            let bic = immContact.get('bic');
            let outsideSepaTerms;
            let ibanOrAccount = immContact.get('iban') || immContact.get('accountNumber');
            const bankName = immBankEntity.get('bankName') || '-';

            if (bankName !== '-' && !immBankEntity.get('isLoading')) {
                recordLinkV2({
                    categoriaEvento: "entidad de destino",
                    accionEvento: "vista",
                    etiquetaEvento: bankName,
                });
            }


            if (isInsideSepa && !immBankEntity.get('isLoading')) {
                ibanOrAccount += ` (${bankName})`;
            }

            if (bic) {
                if (!immBankEntity.get('isLoading')) {
                    bic += ` (${bankName})`;
                }

                outsideSepaTerms = (
                    <div className="transfer-beneficiary-existing__description-section">
                        <dt className="transfer-beneficiary-existing__description-term">
                            <FormattedText value="transferSummary-step1BeneficiaryBicShort" />{COLON}
                        </dt>
                        <dd className="transfer-beneficiary-existing__description-value">
                            {bic}
                        </dd>
                    </div>
                );
            }

            profileContent = (
                <div className="transfer-beneficiary-existing__profile transfer-first-step__form-section">
                    <div className="transfer-beneficiary-existing__profile-avatar-section">
                        <span className="icon-beneficiario transfer-beneficiary-existing__profile-avatar-icon" />
                    </div>
                    <div className="transfer-beneficiary-existing__profile-info-section">
                        <div className="clearfix">
                            <h1 className="transfer-beneficiary-existing__profile-header">
                                <span className="transfer-beneficiary-existing__profile-name">{name} {SLASH} </span>
                                <span className="transfer-beneficiary-existing__profile-alias">{alias}</span>
                            </h1>
                            <div className="transfer-beneficiary-existing__agenda-link pull-right">
                                <OKButton modifier="link-complementary" onClick={actions.handleEditBeneficiary}>
                                    <FormattedText value="transferSummary-step1EditBeneficiary" />
                                </OKButton>
                            </div>
                        </div>
                        <dl className="transfer-beneficiary-existing__description-list">
                            <dt className="transfer-beneficiary-existing__description-term">
                                <FormattedText value="transferSummary-step1BeneficiaryIban" />{COLON}
                            </dt>
                            <dd className="transfer-beneficiary-existing__description-value">
                                {ibanOrAccount}
                            </dd>
                            <dt className="transfer-beneficiary-existing__description-term">
                                {country}
                            </dt>
                            <dd className="transfer-beneficiary-existing__description-value" />
                            {outsideSepaTerms}
                        </dl>
                    </div>

                </div>
            );
        }

        return profileContent;
    }

    buildSelectBeneficiary() {
        const { immBeneficiaryExisting, initialBeneficiaryId, immBeneficiaries} = this.props;

        const labelBeneficiaryName = formatText('transferSummary-step1BeneficiaryNameAlias');


        const selectedBeneficiary = immBeneficiaryExisting.get('id');

        const beneficiaryRequiredAlertVisible = immBeneficiaryExisting.get('isDirty') && immBeneficiaryExisting.get('id') === '';
        let beneficiaryErrorMsg = '';

        if (beneficiaryRequiredAlertVisible) {
            beneficiaryErrorMsg = formatText('transferSummary-requiredMessage', [labelBeneficiaryName]);
        }

        let selectBeneficiaryContent = '';

        if (immBeneficiaries.get('byOrder').size > 0) {
            selectBeneficiaryContent = (
                <div className="transfer-beneficiary-existing__select-beneficiary transfer-first-step__form-section">
                    <SearchBeneficiaries
                        id="drd_TransferStep1_Beneficiary"
                        label={labelBeneficiaryName}
                        onSelect={this.handleBeneficiaryData}
                        selectedValue={selectedBeneficiary}
                        initialValue={initialBeneficiaryId}
                        immBeneficiaries={immBeneficiaries}
                        error={beneficiaryRequiredAlertVisible}
                        errorMsg={beneficiaryErrorMsg}
                    />
                </div>
            );
        }

        return selectBeneficiaryContent;
    }

    handleBeneficiaryData(beneficiaryId) {
        const { actions, requestBeneficiaryDetails, immBeneficiaries, handleBeneficiary } = this.props;
        const immBeneficiary = immBeneficiaries.getIn(['byId', beneficiaryId]);
        const isInsideSepa = isSepa(immBeneficiary.get('country'), immBeneficiary.get('currency'));
        handleBeneficiary(immBeneficiary.get('iban'));
        actions.setBeneficiary(beneficiaryId, immBeneficiary.get('currency'), isInsideSepa, immBeneficiary.get('iban'), immBeneficiary.get('name'));
        requestBeneficiaryDetails(beneficiaryId);
    }

    render() {
        const selectBeneficiarySection = this.buildSelectBeneficiary();
        const profile = this.buildProfile();

        return (
            <div className="transfer-beneficiary-existing">
                {selectBeneficiarySection}
                {profile}
            </div>
        );
    }
}

BeneficiaryExisting.propTypes = {
    actions: PropTypes.object,
    getBankNameFromIban: PropTypes.object,
    getBankNameFromBic: PropTypes.object,
    immBankEntity: PropTypes.object,
    immBeneficiaries: PropTypes.object,
    initialBeneficiaryId: PropTypes.string,
    immBeneficiaryExisting: PropTypes.object,
    requestBeneficiaryDetails: PropTypes.func,
    handleBeneficiary: PropTypes.func.isRequired
};

module.exports = BeneficiaryExisting;

module.exports.constructor = BeneficiaryExisting;
module.exports.BeneficiaryExisting = connect(null, {
    requestBeneficiaryDetails: beneficiariesActions.requestBeneficiaryDetails,
    getBankNameFromIban: bankEntityActions.getBankNameFromIban,
    getBankNameFromBic: bankEntityActions.getBankNameFromBic
})(BeneficiaryExisting);
